var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5333 4.084L17.916 6.46563M18.375 14.875V18.25C18.375 18.8467 18.1379 19.419 17.716 19.841C17.294 20.263 16.7217 20.5 16.125 20.5H3.75C3.15326 20.5 2.58097 20.263 2.15901 19.841C1.73705 19.419 1.5 18.8467 1.5 18.25V5.875C1.5 5.27827 1.73705 4.70597 2.15901 4.28401C2.58097 3.86206 3.15326 3.625 3.75 3.625H7.125M17.0655 1.98588L10.6226 8.42875C10.2897 8.76119 10.0627 9.18473 9.97013 9.646L9.375 12.625L12.354 12.0288C12.8153 11.9365 13.2382 11.7104 13.5712 11.3774L20.0141 4.9345C20.2077 4.74089 20.3613 4.51105 20.4661 4.25808C20.5709 4.00512 20.6248 3.734 20.6248 3.46019C20.6248 3.18639 20.5709 2.91526 20.4661 2.6623C20.3613 2.40934 20.2077 2.17949 20.0141 1.98588C19.8205 1.79227 19.5907 1.63869 19.3377 1.53391C19.0847 1.42913 18.8136 1.3752 18.5398 1.3752C18.266 1.3752 17.9949 1.42913 17.7419 1.53391C17.489 1.63869 17.2591 1.79227 17.0655 1.98588Z",
    stroke: "black",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.5234ac527f91a0109157778be6f2b5e7.svg";